import { render, staticRenderFns } from "./InAppPurchaseForm.vue?vue&type=template&id=34fd9122&scoped=true&"
import script from "./InAppPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./InAppPurchaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd9122",
  null
  
)

export default component.exports